import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startTime", "endTime"]

  connect() {
    // モーダルが開かれたときに日時を設定
    const modal = this.element.closest('.modal')
    if (modal) {
      modal.addEventListener('show.bs.modal', (event) => {
        const button = event.relatedTarget
        if (button && button.dataset.date && button.dataset.time) {
          this.setDateTime(button.dataset.date, button.dataset.time)
        }
      })
    }
  }

  setDateTime(date, time) {
    const dateTime = `${date}T${time}`
    this.startTimeTarget.value = dateTime

    // 終了時間をデフォルトで1時間後に設定
    const startDate = new Date(dateTime)
    startDate.setHours(startDate.getHours() + 1)
    this.endTimeTarget.value = this.formatDateTime(startDate)
  }

  formatDateTime(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  async submit(event) {
    event.preventDefault()
    event.stopPropagation()

    const form = event.target
    const formData = new FormData(form)

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        window.showToast(data.notice || 'ブロックを作成しました', 'success')

        // モーダルを閉じる
        const modal = this.element.closest('.modal')

        if (modal) {
          try {
            // 動的にBootstrapをインポート
            const bootstrap = await import("bootstrap")
            const Modal = bootstrap.Modal

            const bootstrapModal = Modal.getInstance(modal)

            if (bootstrapModal) {
              bootstrapModal.hide()
            }
          } catch (modalError) {
            console.error('Modal error:', modalError)
          }
        }

        // カレンダーを更新
        if (data.calendar_html) {
          const calendarContainer = document.getElementById('reservation-calendar-container')
          if (calendarContainer) {
            calendarContainer.innerHTML = data.calendar_html
          }
        } else {
          // フォールバック: 1秒後にページをリロード
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        }
      } else {
        const data = await response.json()
        // エラーメッセージを表示
        if (data.errors) {
          const errorMessages = Object.entries(data.errors).map(([field, messages]) => {
            return messages.join(', ')
          }).join('\n')
          window.showToast(errorMessages, 'error')
        } else {
          window.showToast('エラーが発生しました', 'error')
        }
      }
    } catch (error) {
      console.error('Error:', error)
      window.showToast('通信エラーが発生しました', 'error')
    }
  }
}
